<template>
  <SoAdminPage
    title="Synchronised Accounts"
    subtitle="Dashboard for managing account synchronisation between Junifer and So Energy system"
  >
    <template #headerRight v-if="!isProdDb">
      <div class="d-flex flex-nowrap gap-1">
        <AdminSyncAccountsLimitInfo
          data-testid="sync-accounts-view-limit-info"
        />

        <SoButton
          type="info"
          icon="help-circle"
          large
          @click="isHelpModalOpen = true"
        />
      </div>
    </template>

    <AdminSyncAccountsTable data-testid="sync-accounts-view-table" />

    <AdminSyncAccountInfoModal v-model="isHelpModalOpen" />
  </SoAdminPage>
</template>
<script lang="ts">
  import { defineComponent } from "vue"
  import SoAdminPage from "@/components/templates/SoAdminPage.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import AdminSyncAccountsTable from "@/views/admin/syncAccounts/components/AdminSyncAccountsTable.vue"
  import AdminSyncAccountInfoModal from "@/views/admin/syncAccounts/modals/AdminSyncAccountInfoModal.vue"
  import AdminSyncAccountsLimitInfo from "@/views/admin/syncAccounts/components/AdminSyncAccountsLimitInfo.vue"

  export default defineComponent({
    components: {
      AdminSyncAccountsLimitInfo,
      AdminSyncAccountInfoModal,
      AdminSyncAccountsTable,
      SoAdminPage,
      SoButton,
    },
    data() {
      return {
        isHelpModalOpen: false,
      }
    },
    computed: {
      isProdDb() {
        return String(import.meta.env.SO_ADMIN_API_URL).includes(".so.energy")
      },
    },
  })
</script>
